import React from 'react'
import { Route, Switch, } from 'react-router-dom'

import withLoggedUser from '~/hoc/withLoggedUser'
import LoginView from '~/views/LoginView'
import SearchView from '~/views/SearchView'
import NotFoundView from '~/views/NotFoundView'

const GlobalRouter = () => {
  return (
    <Switch>
      <Route path="/login" exact component={LoginView} />
      <Route path="/" exact component={withLoggedUser(SearchView)} />
      <Route component={NotFoundView} />
    </Switch>
  )
}

export default React.memo(GlobalRouter)
